import { render } from "./ticket-details.vue?vue&type=template&id=0fa7e932"
import script from "./ticket-details.vue?vue&type=script&lang=js"
export * from "./ticket-details.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__